var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.5898C24 15.7724 22.7357 18.8247 20.4853 21.0751C18.2348 23.3256 15.1826 24.5898 12 24.5898C8.8174 24.5898 5.76516 23.3256 3.51472 21.0751C1.26428 18.8247 0 15.7724 0 12.5898C0 9.40725 1.26428 6.355 3.51472 4.10456C5.76516 1.85413 8.8174 0.589844 12 0.589844C15.1826 0.589844 18.2348 1.85413 20.4853 4.10456C22.7357 6.355 24 9.40725 24 12.5898ZM18.045 8.04484C17.9379 7.93807 17.8103 7.854 17.6699 7.79767C17.5295 7.74133 17.3792 7.71388 17.228 7.71696C17.0768 7.72004 16.9277 7.75359 16.7897 7.8156C16.6518 7.8776 16.5277 7.9668 16.425 8.07784L11.2155 14.7153L8.076 11.5743C7.86274 11.3756 7.58067 11.2674 7.28922 11.2726C6.99776 11.2777 6.71969 11.3958 6.51357 11.6019C6.30745 11.808 6.18938 12.0861 6.18424 12.3776C6.1791 12.669 6.28728 12.9511 6.486 13.1643L10.455 17.1348C10.5619 17.2416 10.6892 17.3257 10.8294 17.3821C10.9695 17.4386 11.1196 17.4662 11.2706 17.4634C11.4217 17.4606 11.5706 17.4274 11.7085 17.3658C11.8465 17.3042 11.9706 17.2155 12.0735 17.1048L18.0615 9.61984C18.2656 9.40759 18.3784 9.12376 18.3756 8.82928C18.3728 8.5348 18.2546 8.25317 18.0465 8.04484H18.045Z",
    fill: "#00BE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFill);
export default __webpack_public_path__ + "static/media/check-circle-fill.c1f2d88c2845c0d0add5e168959d46dd.svg";
export { ForwardRef as ReactComponent };